<template>
  <a-tree-select
      v-model:value="model.parentId"
      style="width: 100%"
      :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
      :tree-data="treeData"
      :replaceFields="{children:'children', title:'label', key:'id', value: 'id' }"
      :placeholder="title"
  >
  </a-tree-select>
</template>
<script>
import {ref} from "vue";
import menuApi from '@axios/sys/menu'
export default {
  componentname: "selectMenuTreeSingle",
  props:{
    title:{
      type:String,
      default:'请选择部门'
    },
    disabled : {
      type:Boolean,
      default:false
    },
    model : {
      type : Object,
      default : function(){
        return {
          parentId : undefined
        }
      }
    }
  },
  setup(props,context){
    let fetching = ref(false);
    let treeData = ref([])
    const menuListTree = ( value ) => {
      let params = {}
      fetching.value = true;
      menuApi.topMenuTree(params).then((res)=>{
        treeData.value = res;
        fetching.value = false;
      }).catch(()=>{
        fetching.value = false;
      })
    }

    const change = (value) => {
      if(value){
        data.value.forEach((ele)=>{
          if(ele.id == value){

            context.emit('setValue',{
              val : value
            });
          }
        })
      }else{
        context.emit('setValue',{
          val : null
        });
      }

    }

    menuListTree();

    return {
      change,
      menuListTree,
      fetching,
      treeData,
      model : props.model
    }
  },
  watch: {
    value(value) {
      console.log(value);
    },
  },
};
</script>
